export const getProvinces = (clientId: string = "conte", country: string = "IT") => {
  const provincesByClient = PROVINCES[clientId];
  if (!provincesByClient) return PROVINCES["conte"]["IT"];
  if (!provincesByClient[country]) {
    if (provincesByClient["IT"]) return provincesByClient["IT"];
    return PROVINCES["conte"]["IT"];
  }
  return PROVINCES[clientId][country];
};

const PROVINCES = {
  conte: {
    IT: [
      "Agrigento",
      "Alessandria",
      "Ancona",
      "Aosta",
      "Arezzo",
      "Ascoli-Piceno",
      "Asti",
      "Avellino",
      "Bari",
      "Barletta-Andria-Trani",
      "Belluno",
      "Benevento",
      "Bergamo",
      "Biella",
      "Bologna",
      "Bolzano",
      "Brescia",
      "Brindisi",
      "Cagliari",
      "Caltanissetta",
      "Campobasso",
      "Caserta",
      "Catania",
      "Catanzaro",
      "Chieti",
      "Como",
      "Cosenza",
      "Cremona",
      "Crotone",
      "Cuneo",
      "Enna",
      "Estero",
      "Fermo",
      "Ferrara",
      "Firenze",
      "Foggia",
      "Forli-Cesena",
      "Frosinone",
      "Genova",
      "Gorizia",
      "Grosseto",
      "Imperia",
      "Isernia",
      "L'Aquila",
      "La-Spezia",
      "Latina",
      "Lecce",
      "Lecco",
      "Livorno",
      "Lodi",
      "Lucca",
      "Macerata",
      "Mantova",
      "Massa-Carrara",
      "Matera",
      "Messina",
      "Milano",
      "Modena",
      "Monza-Brianza",
      "Napoli",
      "Novara",
      "Nuoro",
      "Oristano",
      "Padova",
      "Palermo",
      "Parma",
      "Pavia",
      "Perugia",
      "Pesaro-Urbino",
      "Pescara",
      "Piacenza",
      "Pisa",
      "Pistoia",
      "Pordenone",
      "Potenza",
      "Prato",
      "Ragusa",
      "Ravenna",
      "Reggio-Calabria",
      "Reggio-Emilia",
      "Rieti",
      "Rimini",
      "Roma",
      "Rovigo",
      "Salerno",
      "Sassari",
      "Savona",
      "Siena",
      "Siracusa",
      "Sondrio",
      "Sud Sardegna",
      "Taranto",
      "Teramo",
      "Terni",
      "Torino",
      "Trapani",
      "Trento",
      "Treviso",
      "Trieste",
      "Udine",
      "Varese",
      "Venezia",
      "Verbania",
      "Vercelli",
      "Verona",
      "Vibo-Valentia",
      "Vicenza",
      "Viterbo"
    ],
    Other: ["Estero"],
  },
} as Record<string, Record<string, Array<string>>>;
